import { Codebook } from '../Codebook'
import { CountryId } from '../country/CountryId'

export class PrevioSupportContact extends Codebook<CountryId> {
  static readonly CZE = new PrevioSupportContact(
    CountryId.CZE,
    '+420 251 613 924',
    'info@previo.cz',
  )
  static readonly SVK = new PrevioSupportContact(
    CountryId.SVK,
    '+421 220 510 456',
    'info@previo.sk',
  )
  static readonly POL = new PrevioSupportContact(
    CountryId.POL,
    '+48 730 013 514',
    'support@previo.com.pl',
  )
  static readonly HUN = new PrevioSupportContact(
    CountryId.HUN,
    '+36 1 445 3737',
    'support@previo.hu',
  )
  static readonly ROU = new PrevioSupportContact(CountryId.ROU, '+40 377 102 388', 'info@previo.ro')

  private constructor(
    id: CountryId,
    public readonly phone: string,
    public readonly email: string,
  ) {
    super(id)
  }

  static forCountry(countryId: CountryId): PrevioSupportContact {
    return PrevioSupportContact.contains(countryId)
      ? PrevioSupportContact.getById(countryId)
      : PrevioSupportContact.CZE
  }
}
